export default __webpack_public_path__ + "static/slider.aktirol.klein-25f047b25463b4322a154650e9d67a6b.webp";